import { connect } from 'react-redux';
import { State } from 'store/types';
import View from './View';
import { fetchSearchSuggestion, updateSearchField, toggleVoiceModal } from 'store/searchSuggestions/action';
import { isEligible } from 'store/app/selector';


const mapDispatchToProps = {
  fetchSearchSuggestion,
  updateSearchField,
  toggleVoiceModal,
};

const mapStateToProps = (state: State) => {
  const { appReducer, remoteConfig, auth, searchSuggestions } = state;
  return {
    pageType: appReducer.pageType,
    maxSearchHistoryCount: remoteConfig.configs.maxSearchHistoryCount,
    isPro: auth.user.isPro,
    searchField: searchSuggestions.searchField || '',
    showVoiceModal: searchSuggestions.showVoiceModal || false,
    hasVoiceSearch: isEligible(remoteConfig.configs?.AB?.voiceSearch, appReducer.run),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View);
